import { render, staticRenderFns } from "./KpiShow.vue?vue&type=template&id=5dd9f090&scoped=true&"
import script from "./KpiShow.vue?vue&type=script&lang=js&"
export * from "./KpiShow.vue?vue&type=script&lang=js&"
import style0 from "./KpiShow.vue?vue&type=style&index=0&id=5dd9f090&prod&scoped=true&lang=css&"
import style1 from "./KpiShow.vue?vue&type=style&index=1&id=5dd9f090&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9f090",
  null
  
)

export default component.exports